var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6293 7.31818L10.4006 14.3828H8.35724L8.12855 7.31818H10.6293ZM9.37642 17.6442C9.02178 17.6442 8.71686 17.5182 8.46165 17.2663C8.20975 17.0144 8.08381 16.7095 8.08381 16.3516C8.08381 16.0002 8.20975 15.7003 8.46165 15.4517C8.71686 15.1998 9.02178 15.0739 9.37642 15.0739C9.7178 15.0739 10.0178 15.1998 10.2763 15.4517C10.5381 15.7003 10.669 16.0002 10.669 16.3516C10.669 16.5902 10.6077 16.8073 10.4851 17.0028C10.3658 17.1984 10.2083 17.3542 10.0128 17.4702C9.82055 17.5862 9.60843 17.6442 9.37642 17.6442ZM15.3871 7.31818L15.1584 14.3828H13.1151L12.8864 7.31818H15.3871ZM14.1342 17.6442C13.7796 17.6442 13.4747 17.5182 13.2195 17.2663C12.9676 17.0144 12.8416 16.7095 12.8416 16.3516C12.8416 16.0002 12.9676 15.7003 13.2195 15.4517C13.4747 15.1998 13.7796 15.0739 14.1342 15.0739C14.4756 15.0739 14.7756 15.1998 15.0341 15.4517C15.2959 15.7003 15.4268 16.0002 15.4268 16.3516C15.4268 16.5902 15.3655 16.8073 15.2429 17.0028C15.1236 17.1984 14.9661 17.3542 14.7706 17.4702C14.5784 17.5862 14.3662 17.6442 14.1342 17.6442Z",
    fill: "#1E233E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionToday);
export default __webpack_public_path__ + "static/media/attention-today.ed5ec71a7ffce3f63d6b375792323b35.svg";
export { ForwardRef as ReactComponent };